<template>
  <div class="container">
    <div class="mt-5">
      <h1 class="text-left">Permissions Group Creator</h1>

      <div class="mt-5">
        <v-text-field label="Group Name" v-model="name"></v-text-field>

        <v-row no-gutters class="my-5">
          <v-col>
            <v-btn elevation="2" class="mr-5" @click.stop="selectAll"
              >Select All</v-btn
            >
            <v-btn elevation="2" @click.stop="deSelect">Select None</v-btn>
          </v-col>
          <v-col class="text-right">
            <v-btn
              elevation="2"
              class="mr-5"
              @click.stop="remove"
              color="error"
              v-if="
                typeof this.$props.selectedItem != 'undefined' ||
                this.$props.selectedItem != null
              "
              >Delete</v-btn
            >
            <v-btn elevation="2" class="mr-5" @click.stop="cancel"
              >Cancel</v-btn
            >
            <v-btn elevation="2" @click.stop="save">Save Group</v-btn>
          </v-col>
        </v-row>
      </div>

      <v-simple-table class="my-5">
        <template v-slot:default>
          <thead>
            <tr>
              <h2>
                <b><th class="text-left">Organizations</th></b>
              </h2>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(organization, index) in organizations" :key="index">
              <td
                v-for="organizationSingle in organization"
                :key="organizationSingle.organization"
              >
                <v-checkbox
                  :label="`${organizationSingle.organization}`"
                  v-model="organizationSingle.selected"
                ></v-checkbox>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <div class="my-5">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <h2>
                <b><th class="text-left">Roles</th></b>
              </h2>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(role, index) in roles" :key="index">
              <td v-for="roleSingle in role" :key="roleSingle.role">
                <v-checkbox
                  :label="`${roleSingle.role}`"
                  v-model="roleSingle.selected"
                ></v-checkbox>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import permission from "./permission.controller.js";

export default {
  name: "Table",
  route: {
    name: "table",
    path: "/table",
  },
  props: ["selectedItem"],
  watch: {
    selectedItem: function (newVal) {
      this.getSorted(newVal.id);
    },
  },
  data() {
    return {
      roles: [
        {
          role: "Admin",
          selected: false,
        },
      ],
      organizations: [
        {
          organization: "Admin",
          selected: false,
        },
      ],
      name: "",
      id: "",
    };
  },
  mounted() {
    this.getOrganizations();
    this.getRoles();
  },
  computed: {},
  methods: {
    selectAll() {
      this.organizations.forEach((row) => {
        row.forEach((organization) => {
          organization.selected = true;
        });
      });
      this.roles.forEach((row) => {
        row.forEach((role) => {
          role.selected = true;
        });
      });
    },
    deSelect() {
      this.organizations.forEach((row) => {
        row.forEach((organization) => {
          organization.selected = false;
        });
      });
      this.roles.forEach((row) => {
        row.forEach((role) => {
          role.selected = false;
        });
      });
    },
    async getSorted(id) {
      let _permissions = await permission.getSorted(id);
      this.name = _permissions.name;
      this.organizations = _permissions.organizations;
      this.roles = _permissions.roles;
      this.id = _permissions.id;
    },
    async remove() {
      if (confirm("Confirm deletion of group: " + this.name)) {
        let results = await permission.delete(this.id);
        if (results.error) {
          alert(results.error);
        }
        this.$emit("updated");
      }
    },
    async save() {
      if (
        typeof this.$props.selectedItem == "undefined" ||
        this.$props.selectedItem == null
      ) {
        let results = await permission.add({
          name: this.name,
          organizations: this.organizations.flat(),
          roles: this.roles.flat(),
        });
        if (results.error) {
          alert(results.error);
        }

        this.name = "";
        this.getOrganizations();
        this.getRoles();
        this.$emit("saved");
      } else {
        let results = await permission.update({
          name: this.name,
          organizations: this.organizations.flat(),
          roles: this.roles.flat(),
          id: this.id,
        });
        if (results.error) {
          alert(results.error);
        }
        this.$emit("updated");
      }
    },
    async cancel() {
      this.name = "";
      this.getOrganizations();
      this.getRoles();
      this.$emit("cancel");
    },
    async getOrganizations() {
      this.organizations = await permission.getOrganizations();
    },
    async getRoles() {
      this.roles = await permission.getRoles();
    },
  },
};
</script>